/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { iAuthResponse } from './types'

export interface iAuthData extends iAuthResponse {
  isAuthenticated: boolean
}
export interface iStore {
  auth: iAuthData
  authServerLoginUri: string
  authServerLogoutUri: string
  authServerTokenUri: string
  authServerTokenSSOUri?: string
  client_id: string
  redirect_uri?: string
  scope?: string
  withState?: boolean
  additionalParams?: Record<string, string>
  autoRefresh?: boolean
  cancelRefreshOnTime?: () => void
  autoRefreshTime?: number
}
const store = {} as iStore

type iPut = <T extends keyof iStore>(
  key: T,
  value: iStore[T],
) => iStore[T]
const put: iPut = (key, value) => {
  store[key] = value
  return value
}

type iGet = <T extends keyof iStore>(key: T) => iStore[T]
const get: iGet = (key) => store[key]

export { get, put }
